import { mailTo } from '@helpers';
import DarkLogo from '@static/images/brand/logo-dark.svg';
import LightLogo from '@static/images/brand/logo-light.svg';
import WebMaintenance from '@static/images/reflexivity/web-maintenance.svg';
import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';
import { isDarkTheme } from '@terminal/components/theme-controller/utils/theme-utils/theme-utils';
import { config } from '@terminal/config';
import { Trans, useTranslation } from 'react-i18next';

import styles from './Maintenance.module.scss';

export const Maintenance = () => {
  const { t } = useTranslation('common');
  const themeName = useThemeStore(state => state.themeName);
  const isDark = isDarkTheme(themeName);
  const supportEmail = mailTo(config.supportEmail);

  const ThemedLogo = isDark ? DarkLogo : LightLogo;

  return (
    <section className={styles.maintenanceRoot} data-testid="maintenance-mode">
      <aside className={styles.logo}>
        <ThemedLogo />
      </aside>
      <h1 className={styles.tagline}>
        <Trans
          t={t}
          i18nKey="common:maintenance.tagline"
          components={[<span className={styles.taglineAlt} key="" />]}
        />
      </h1>
      <section className={styles.description}>
        <p className={styles.textContent}>
          <Trans
            t={t}
            i18nKey="common:maintenance.textContent"
            components={[
              <a
                className={styles.styledAnchor}
                key="key-1"
                href={supportEmail}
              />,
            ]}
            values={{ email: config.supportEmail }}
          />
        </p>
        <aside className={styles.image}>
          <WebMaintenance />
        </aside>
      </section>
    </section>
  );
};
